export function getBackgroundImageStyle(imgSrc) {
    return { 'background-image': imgSrc ? "url(" + imgSrc + ")" : 'none' };
}
